import React from 'react'
import { useSelector } from 'react-redux';
import { selectCurrentStep } from '../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import { useCreateProposalForm } from '../../hooks/actions/use-create-proposal-form';
import { useModalInfo } from '../../hooks/common/use-modal-info';
import HeaderProgress from '../../components/module/create-proposal/common/header-progress';
import FirstStep from '../../components/module/create-proposal/steps/first-step/first-step';
import SecondStep from '../../components/module/create-proposal/steps/second-step/second-step';
import ThirdStep from '../../components/module/create-proposal/steps/third-step/third-step';
import FourthStep from '../../components/module/create-proposal/steps/fourth-step/fourth-step';
import ConfirmDefaultModal from '../../components/global/modal/confirm-default-modal';

export default function CreateRenewal() {
    return (
        <div className="flex min-h-[70vh] items-center justify-center px-4 py-10">
            <div className="w-full max-w-md text-center">
                <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-2xl bg-[#E3F1FA] text-[#186cb2]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14.7 6.3a4.5 4.5 0 0 0-6 6L3 18l3 3 5.7-5.7a4.5 4.5 0 0 0 6-6L15 12l-3-3z" />
                        <path d="m16 5 3-3 3 3-3 3" />
                    </svg>
                </div>
                <span className="mb-3 inline-flex items-center rounded-full border border-[#C7E0F3] bg-[#EEF6FC] px-3 py-1 text-xs font-semibold text-[#186cb2]">
                    Under Development
                </span>
                <h1 className="text-2xl font-bold tracking-tight text-[#102F50]">
                    Renewal
                </h1>
                <p className="mt-3 text-sm leading-6 text-gray-500">
                    We're currently working on this feature to provide you with a better experience.
                    The Renewal module will be available soon.
                </p>
                <div className="mt-7 flex items-center justify-center gap-2 text-xs text-gray-400">
                    <span className="h-2 w-2 animate-pulse rounded-full bg-[#00A878]" />
                    Our team is working on it
                </div>
            </div>
        </div>
    );

    // const currentStep = useSelector(selectCurrentStep);
    // const { 
    //     isSaveProposal, 
    //     setIsSaveProposal, 
    //     handleSaveClientData, 
    //     handleSubmitProposal, 
    //     isLoading, 
    //     submitType, 
    // } = useCreateProposalForm();
    // const { modalTitle, modalSubTitle, } = useModalInfo(submitType);
    // const proposalAsType = "renewal";
    // const proposalAsTypeRenewal: boolean = true;

    // return (
    //     <>
    //         <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-[#f5f9fd] rounded-xl border border-gray-200/80">
    //             {/* ================================================= */}
    //             {/* HEADER PROGRESS */}
    //             {/* ================================================= */}
    //             <div className="sticky top-0 z-20 flex-shrink-0 border-b border-gray-200 bg-white p-3 py-3 shadow-sm sm:px-4 lg:px-5">
    //                 <HeaderProgress handleSaveClientData={handleSaveClientData} hasDraft={false} isRenewal={true} />
    //             </div>
    //             {/* ================================================= */}
    //             {/* STEP CONTENT */}
    //             {/* ================================================= */}
    //             <div className="min-h-0 flex-1 overflow-y-auto">
    //                 <div className="w-full px-3 py-3">
    //                     {currentStep === 1 && <FirstStep isRenewal={true} />}
    //                     {currentStep === 2 && <SecondStep />}
    //                     {currentStep === 3 && <ThirdStep />}
    //                     {currentStep === 4 && <FourthStep />}
    //                 </div>
    //             </div>
    //         </div>
    //         {/* ================================================= */}
    //         {/* SAVE PROPOSAL MODAL */}
    //         {/* ================================================= */}
    //         {isSaveProposal && (
    //             <ConfirmDefaultModal
    //                 modalTitle={modalTitle}
    //                 modalSubTitle={modalSubTitle}
    //                 onCancel={() => setIsSaveProposal(false)}
    //                 onConfirm={handleSubmitProposal}
    //                 isLoading={isLoading}
    //             />
    //         )}
    //     </>
    // );
}